/* eslint-disable react/jsx-key */
/* eslint-disable react/jsx-id */
import React from 'react'
import { Route } from 'react-router-dom'
import _ from 'lodash'
import DriverPage from '../pages/driver-page/list'
import DriverDetail from '../pages/driver-page/detail'
import DriverSalary from '../pages/driver-page/detail/salaryPage'
import GasPage from '../pages/gas-page/list'
import GasDetail from '../pages/gas-page/detail'
import MechanicPage from '../pages/mechanics-page/list'
import MechanicDetail from '../pages/mechanics-page/detail'
import MechanicSalary from '../pages/mechanics-page/detail/salaryPage'
import TruckPage from '../pages/truck-page/list'
import TruckViewLog from '../pages/truck-page/detail/viewLog'
import TruckTireList from '../pages/truck-page/detail/tireList'
import TruckTireHistory from '../pages/truck-page/detail/tireHistory'
import TruckDetail from '../pages/truck-page/detail'
import TrailerPage from '../pages/trailer-page/list'
import TrailerViewLog from '../pages/trailer-page/detail/viewLog'
import TrailerTireList from '../pages/trailer-page/detail/tireList'
import TrailerTireHistory from '../pages/trailer-page/detail/tireHistory'
import TrailerDetail from '../pages/trailer-page/detail'
import ClientPage from '../pages/client-page/list'
import ClientDetail from '../pages/client-page/detail'
import ShippingOrderPage from '../pages/shipping-order-page/list'
import ShippingOrderDetail from '../pages/shipping-order-page/detail'
import FillingOrderPage from '../pages/filling-order-page/list'
import FillingOrderDetail from '../pages/filling-order-page/detail'
import CreateSpecialFillingOrderPage from '../pages/filling-order-page/create-special'
import InvoicePage from '../pages/invoice-page/list'
import { Index as InvoiceDetail } from '../pages/invoice-page/detail'
import InvoicePaid from '../pages/invoice-page/detail/paidPage'
import UpdateInvoice from '../pages/invoice-page/detail/invoice-update-shipping'
import RoleList from '../pages/role-page/list'
import UserList from '../pages/user-page/list'
import UserDetail from '../pages/user-page/detail'
import BillPage from '../pages/bill-page/list'
import BillDetail from '../pages/bill-page/detail'
import BillPaid from '../pages/bill-page/detail/paidPage'
import StartPointPage from '../pages/start-point-page/list'
import StartPointDetail from '../pages/start-point-page/detail'
import DestinationPage from '../pages/destination-page/list'
import ReportPage from '../pages/report-page/list'
import ExpensePage from '../pages/expense-page'
import Dashboard from '../pages/dashboard'
import FuelCostSummary from '../pages/fuel-summary'
import RepairList from '../pages/repair-job-page/list'
import RepairDetail from '../pages/repair-job-page/detail'
import DestinationDetail from '../pages/destination-page/detail'
import { detail as TruckOwnerDetail, list as TruckOwnerList } from '../pages/truckowner-page'
import { detail as JobDetail, list as JobPage } from '../pages/job-page'
import PERMISSIONS from '../constants/permissions'
import GaragePage from '../pages/garages-page/list'
import GarageDetail from '../pages/garages-page/detail'
import TirePatchShopPage from '../pages/tire-patch-shop-page/list'
import TirePatchShopDetail from '../pages/tire-patch-shop-page/detail'
import TirePatchPage from '../pages/tire-patch-page/list'
import TirePatchDetail from '../pages/tire-patch-page/detail'
import InventoryPage from '../pages/inventory-page/list/index'
import TireInventoryPage from '../pages/tire-inventory-page/list/index'
import TireInventoryView from '../pages/tire-inventory-page/detail/quick-view'
import TireInventoryEdit from '../pages/tire-inventory-page/detail/form'
import TireInventoryTransfer from '../pages/tire-inventory-page/detail/transfer-stock'
import TireInventoryAdjust from '../pages/tire-inventory-page/detail/adjust-stock'
import TireInventoryHistory from '../pages/tire-inventory-page/detail/history'
import TireInventoryUsedHistory from '../pages/tire-inventory-page/detail/usedHistory'
import InventoryView from '../pages/inventory-page/detail/quick-view'
import InventoryEdit from '../pages/inventory-page/detail/form'
import InventoryTransfer from '../pages/inventory-page/detail/transfer-stock'
import InventoryAdjust from '../pages/inventory-page/detail/adjust-stock'
import InventoryHistory from '../pages/inventory-page/detail/history'
import PurchaseOrderPage from '../pages/purchase-order-page/list/index'
import PurchaseOrderEdit from '../pages/purchase-order-page/detail/form'
import PurchaseOrderView from '../pages/purchase-order-page/detail/quick-view'
import GoodReceivedPage from '../pages/good-received-page/list/index'
import GoodReceivedEdit from '../pages/good-received-page/detail/form'
import GoodReceivedView from '../pages/good-received-page/detail/quick-view'
import TireGoodReceivedPage from '../pages/tire-good-received-page/list/index'
import TireGoodReceivedEdit from '../pages/tire-good-received-page/detail/form'
import TireGoodReceivedView from '../pages/tire-good-received-page/detail/quick-view'
import WarehousePage from '../pages/warehouses-page/list/index'
import WarehouseView from '../pages/warehouses-page/detail/quick-view'
import WarehouseEdit from '../pages/warehouses-page/detail/form'
import SupplierPage from '../pages/suppliers-page/list/index'
import SupplierView from '../pages/suppliers-page/detail/quick-view'
import SupplierEdit from '../pages/suppliers-page/detail/form'
import PurchaseRequisitionPage from '../pages/purchase-requisition-page/list/index'
import PurchaseRequisitionDetail from '../pages/purchase-requisition-page/detail/index'
import DriverCompensation from '../pages/driver-compensation'
import JobHistory from '../pages/job-page/history'
import TruckHistory from '../pages/truck-page/history'
import ShippingOrderHistory from '../pages/shipping-order-page/history'
import RecommendFuelPage from '../pages/recommend-fuel-page/list'

const routes = [
  {
    key: 'VIEW_TRUCK_LIST',
    id: 'TRUCK',
    action: PERMISSIONS.VIEW_TRUCK,
    component: <Route key='VIEW_TRUCK_LIST' path='/truck' exact component={TruckPage} />,
  }, {
    key: 'UPDATE_TRUCK',
    id: 'TRUCK',
    action: PERMISSIONS.UPDATE_TRUCK,
    component: <Route path='/truck/edit/:id' component={route => <TruckDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_TRUCK_DETAIL',
    id: 'TRUCK',
    action: PERMISSIONS.VIEW_TRUCK,
    component: <Route key='VIEW_TRUCK_DETAIL' path='/truck/view/:id' component={route => <TruckDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_TRUCK',
    id: 'TRUCK',
    action: PERMISSIONS.CREATE_TRUCK,
    component: <Route path='/truck/add/' component={route => <TruckDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'VIEW_TRUCK_LOG',
    id: 'TRUCK',
    action: PERMISSIONS.VIEW_TRUCK,
    component: <Route key='VIEW_TRAILER_LIST' path='/truck/view-log/:id' component={route => <TruckViewLog props={{ ...route, match: { ...route.match } }} />} />,
  }, {
    key: 'VIEW_TRUCK_TIRE_LIST',
    id: 'TRUCK',
    action: PERMISSIONS.VIEW_TRUCK,
    component: <Route key='VIEW_TRUCK_TIRE_LIST' path='/truck/tire-list/:id' component={route => <TruckTireList props={{ ...route, match: { ...route.match } }} />} />,
  }, {
    key: 'VIEW_TRUCK_TIRE_HISTORY',
    id: 'TRUCK',
    action: PERMISSIONS.VIEW_TRUCK,
    component: <Route key='VIEW_TRUCK_TIRE_HISTORY_LIST' path='/truck/tire-history/:id' component={route => <TruckTireHistory props={{ ...route, match: { ...route.match } }} />} />,
  }, {
    key: 'VIEW_TRUCKOWNER_LIST',
    id: 'TRUCK',
    action: PERMISSIONS.VIEW_TRUCK,
    component: <Route path='/truckowner' key='VIEW_TRUCKOWNER_LIST' exact component={TruckOwnerList} />,
  }, {
    key: 'UPDATE_TRUCKONWER',
    id: 'TRUCK',
    action: PERMISSIONS.UPDATE_TRUCK,
    component: <Route path='/truckowner/edit/:id' component={route => <TruckOwnerDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_TRUCKOWNER_DETAIL',
    id: 'TRUCK',
    action: PERMISSIONS.VIEW_TRUCK,
    component: <Route path='/truckowner/view/:id' key='VIEW_TRUCKOWNER_DETAIL' component={route => <TruckOwnerDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_TRUCKOWNER',
    id: 'TRUCK',
    action: PERMISSIONS.CREATE_TRUCK,
    component: <Route path='/truckowner/add/' component={route => <TruckOwnerDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'VIEW_DRIVER_LIST',
    id: 'DRIVER',
    action: PERMISSIONS.VIEW_DRIVER,
    component: <Route path='/driver' key='VIEW_DRIVER_LIST' exact component={DriverPage} />,
  }, {
    key: 'UPDATE_DRIVER',
    id: 'DRIVER',
    action: PERMISSIONS.UPDATE_DRIVER,
    component: <Route path='/driver/edit/:id' component={route => <DriverDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_DRIVER_DETIAL',
    id: 'DRIVER',
    action: PERMISSIONS.VIEW_DRIVER,
    component: <Route path='/driver/view/:id' key='VIEW_DRIVER_DETIAL' component={route => <DriverDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_DRIVER',
    id: 'DRIVER',
    action: PERMISSIONS.CREATE_DRIVER,
    component: <Route path='/driver/add/' component={route => <DriverDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'CREATE_SALARY',
    id: 'DRIVER',
    action: PERMISSIONS.CREATE_SALARY,
    component: <Route path='/driver/salary/:id' component={route => <DriverSalary props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_GAS_STATION_LIST',
    id: 'GAS_STATION',
    action: PERMISSIONS.VIEW_GAS_STATION,
    component: <Route path='/gas-station' key='VIEW_GAS_STATION_LIST' exact component={GasPage} />,
  }, {
    key: 'UPDATE_GAS_STATION',
    id: 'GAS_STATION',
    action: PERMISSIONS.UPDATE_GAS_STATION,
    component: <Route path='/gas-station/edit/:id' key='UPDATE_GAS_STATION' component={route => <GasDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_GAS_STATION_DETAIL',
    id: 'GAS_STATION',
    action: PERMISSIONS.VIEW_GAS_STATION,
    component: <Route path='/gas-station/view/:id' key='VIEW_GAS_STATION_DETAIL' component={route => <GasDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_GAS_STATION',
    id: 'GAS_STATION',
    action: PERMISSIONS.CREATE_GAS_STATION,
    component: <Route path='/gas-station/add/' key='CREATE_GAS_STATION' component={route => <GasDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'VIEW_CLIENT_LIST',
    id: 'CLIENT',
    action: PERMISSIONS.VIEW_CLIENT,
    component: <Route path='/client' key='VIEW_CLIENT_LIST' exact component={ClientPage} />,
  }, {
    key: 'UPDATE_CLIENT',
    id: 'CLIENT',
    action: PERMISSIONS.UPDATE_CLIENT,
    component: <Route path='/client/edit/:id' component={route => <ClientDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_CLIENT_DETAIL',
    id: 'CLIENT',
    action: PERMISSIONS.VIEW_CLIENT,
    component: <Route path='/client/view/:id' key='VIEW_CLIENT_DETAIL' component={route => <ClientDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_CLIENT',
    id: 'CLIENT',
    action: PERMISSIONS.CREATE_CLIENT,
    component: <Route path='/client/add/' component={route => <ClientDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'VIEW_SHIPPING_ORDER_LIST',
    id: 'SHIPPING_ORDER',
    action: PERMISSIONS.VIEW_SHIPPING_ORDER,
    component: <Route path='/shipping-order' key='VIEW_SHIPPING_ORDER_LIST' exact component={ShippingOrderPage} />,
  }, {
    key: 'VIEW_SHIPPING_ORDER_LIST',
    id: 'SHIPPING_ORDER',
    action: PERMISSIONS.VIEW_SHIPPING_ORDER,
    component: <Route path='/shipping-order/status/:status' key='VIEW_SHIPPING_ORDER_LIST' exact component={route => <ShippingOrderPage props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'UPDATE_SHIPPING_ORDER',
    id: 'SHIPPING_ORDER',
    action: PERMISSIONS.UPDATE_SHIPPING_ORDER,
    component: <Route path='/shipping-order/edit/:shippingVolume/:shippingNumber' component={route => <ShippingOrderDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'UPDATE_SHIPPING_ORDER',
    id: 'SHIPPING_ORDER',
    action: PERMISSIONS.UPDATE_SHIPPING_ORDER,
    component: <Route path='/shipping-order/edit/:id' component={route => <ShippingOrderDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'ASSIGN_SHIPPING_ORDER',
    id: 'SHIPPING_ORDER',
    action: PERMISSIONS.ASSIGN_SHIPPING_ORDER,
    component: <Route path='/shipping-order/edit/:id' component={route => <ShippingOrderDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'CREATE_FUEL',
    id: 'SHIPPING_ORDER',
    action: PERMISSIONS.CREATE_FUEL,
    component: <Route path='/shipping-order/edit/:id' key='CREATE_FUEL' component={route => <ShippingOrderDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'RECORD_DELIVERY_SHIPPING_ORDER',
    id: 'SHIPPING_ORDER',
    action: PERMISSIONS.RECORD_DELIVERY_SHIPPING_ORDER,
    component: <Route path='/shipping-order/edit/:id' component={route => <ShippingOrderDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_SHIPPING_ORDER_DETAIL',
    id: 'SHIPPING_ORDER',
    action: PERMISSIONS.VIEW_SHIPPING_ORDER,
    component: <Route path='/shipping-order/view/:shippingVolume/:shippingNumber' key='VIEW_SHIPPING_ORDER_DETAIL' component={route => <ShippingOrderDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'VIEW_SHIPPING_ORDER_DETAIL',
    id: 'SHIPPING_ORDER',
    action: PERMISSIONS.VIEW_SHIPPING_ORDER,
    component: <Route path='/shipping-order/view/:id' key='VIEW_SHIPPING_ORDER_DETAIL' component={route => <ShippingOrderDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_SHIPPING_ORDER',
    id: 'SHIPPING_ORDER',
    action: PERMISSIONS.CREATE_SHIPPING_ORDER,
    component: <Route path='/shipping-order/add/:id' component={route => <ShippingOrderDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'VIEW_FUEL_LIST',
    id: 'FUEL',
    action: PERMISSIONS.VIEW_FUEL,
    component: <Route path='/fill-order' key='VIEW_FUEL_LIST' exact component={FillingOrderPage} />,
  }, {
    key: 'UPDATE_FUEL',
    id: 'FUEL',
    action: PERMISSIONS.UPDATE_FUEL,
    component: <Route path='/fill-order/edit/:id' key='UPDATE_FUEL' component={route => <FillingOrderDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_FUEL_DETAIL',
    id: 'FUEL',
    action: PERMISSIONS.VIEW_FUEL,
    component: <Route path='/fill-order/view/:id' key='VIEW_FUEL_DETAIL' component={route => <FillingOrderDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_FUEL_IN_FUEL',
    id: 'FUEL',
    action: PERMISSIONS.CREATE_FUEL,
    component: <Route path='/fill-order/add/' key='CREATE_FUEL_IN_FUEL' component={route => <FillingOrderDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'CREATE_SPECIAL_FUEL',
    id: 'FUEL',
    action: PERMISSIONS.CREATE_FUEL,
    component: <Route path='/fill-order/create-special/' key='CREATE_SPECIAL_FUEL' component={() => <CreateSpecialFillingOrderPage />} />,
  }, {
    key: 'VIEW_INVOICE_LIST',
    id: 'INVOICE',
    action: PERMISSIONS.VIEW_INVOICE,
    component: <Route path='/invoice' key='VIEW_INVOICE_LIST' exact component={InvoicePage} />,
  }, {
    key: 'UPDATE_INVOICE',
    id: 'INVOICE',
    action: PERMISSIONS.UPDATE_INVOICE,
    component: <Route path='/invoice/edit/:id' component={route => <InvoiceDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'PAID_INVOICE',
    id: 'INVOICE',
    action: PERMISSIONS.RECEIVE_PAYMENT_INVOICE,
    component: <Route path='/invoice/paid/:id' component={route => <InvoicePaid props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'UPDATE_INVOICE_ADD_REMOVE_SHIPPING_ORDER',
    id: 'INVOICE',
    action: PERMISSIONS.UPDATE_INVOICE,
    component: <Route path='/invoice/update/:id' exact component={route => <UpdateInvoice props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'VIEW_INVOICE_DETAIL',
    id: 'INVOICE',
    action: PERMISSIONS.VIEW_INVOICE,
    component: <Route path='/invoice/view/:id' key='VIEW_INVOICE_DETAIL' component={route => <InvoiceDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_INVOICE',
    id: 'INVOICE',
    action: PERMISSIONS.CREATE_INVOICE,
    component: <Route path='/invoice/add/' component={route => <InvoiceDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'VIEW_JOB_LIST',
    id: 'JOB',
    action: PERMISSIONS.VIEW_JOB,
    component: <Route path='/job' key='VIEW_JOB_LIST' exact component={JobPage} />,
  }, {
    key: 'UPDATE_JOB',
    id: 'JOB',
    action: PERMISSIONS.UPDATE_JOB,
    component: <Route path='/job/edit/:id' component={route => <JobDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_JOB_DETAIL',
    id: 'JOB',
    action: PERMISSIONS.VIEW_JOB,
    component: <Route path='/job/view/:id' key='VIEW_JOB_DETAIL' component={route => <JobDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_JOB',
    id: 'JOB',
    action: PERMISSIONS.CREATE_JOB,
    component: <Route path='/job/add/' component={route => <JobDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'VIEW_PURCHASE_REQUISITION_LIST',
    id: 'PURCHASE_REQUISITION',
    action: PERMISSIONS.VIEW_PURCHASE_REQUISITION,
    component: <Route path='/purchase-requisition' key='VIEW_PURCHASE_REQUISITION_LIST' exact component={PurchaseRequisitionPage} />,
  }, {
    key: 'UPDATE_PURCHASE_REQUISITION',
    id: 'PURCHASE_REQUISITION',
    action: PERMISSIONS.UPDATE_PURCHASE_REQUISITION,
    component: <Route path='/purchase-requisition/edit/:id' component={route => <PurchaseRequisitionDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_PURCHASE_REQUISITION_DETAIL',
    id: 'PURCHASE_REQUISITION',
    action: PERMISSIONS.VIEW_PURCHASE_REQUISITION,
    component: <Route path='/purchase-requisition/view/:id' key='VIEW_PURCHASE_REQUISITION_DETAIL' component={route => <PurchaseRequisitionDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_PURCHASE_REQUISITION',
    id: 'PURCHASE_REQUISITION',
    action: PERMISSIONS.CREATE_PURCHASE_REQUISITION,
    component: <Route path='/purchase-requisition/add/' component={route => <PurchaseRequisitionDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'VIEW_USER_LIST',
    id: 'USER',
    action: PERMISSIONS.VIEW_USER,
    component: <Route path='/user' key='CREATE_JOB_LIST' exact component={UserList} />,
  }, {
    key: 'UPDATE_USER',
    id: 'USER',
    action: PERMISSIONS.UPDATE_USER,
    component: <Route path='/user/edit/:id' component={route => <UserDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_USER_DETAIL',
    id: 'USER',
    action: PERMISSIONS.VIEW_USER,
    component: <Route path='/user/view/:id' key='VIEW_USER_DETAIL' component={route => <UserDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'VIEW_BILL_LIST',
    id: 'BILL',
    action: PERMISSIONS.VIEW_BILL,
    component: <Route path='/bill' key='VIEW_BILL_LIST' exact component={BillPage} />,
  }, {
    key: 'UPDATE_BILL',
    id: 'BILL',
    action: PERMISSIONS.UPDATE_BILL,
    component: <Route path='/bill/edit/:id' component={route => <BillDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_BILL_DETAIL',
    id: 'BILL',
    action: PERMISSIONS.VIEW_BILL,
    component: <Route path='/bill/view/:id' key='VIEW_BILL_DETAIL' component={route => <BillDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_BILL',
    id: 'BILL',
    action: PERMISSIONS.CREATE_BILL,
    component: <Route path='/bill/add/' component={route => <BillDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'PAID_BILL',
    id: 'BILL',
    action: PERMISSIONS.RECEIVE_PAYMENT_BILL,
    component: <Route path='/bill/paid/:id' component={route => <BillPaid props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_ROLE',
    id: 'ROLE',
    action: PERMISSIONS.VIEW_ROLE,
    component: <Route path='/role' component={RoleList} />,
  }, {
    key: 'VIEW_STARTPOINT_LIST',
    id: 'STARTPOINT',
    action: PERMISSIONS.VIEW_STARTPOINT,
    component: <Route path='/start-point' key='VIEW_STARTPOINT_LIST' exact component={StartPointPage} />,
  }, {
    key: 'UPDATE_STARTPOINT',
    id: 'STARTPOINT',
    action: PERMISSIONS.UPDATE_STARTPOINT,
    component: <Route path='/start-point/edit/:id' component={route => <StartPointDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_STARTPOINT_DETAIL',
    id: 'STARTPOINT',
    action: PERMISSIONS.VIEW_STARTPOINT,
    component: <Route path='/start-point/view/:id' key='VIEW_STARTPOINT_DETAIL' component={route => <StartPointDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_STARTPOINT',
    id: 'STARTPOINT',
    action: PERMISSIONS.CREATE_STARTPOINT,
    component: <Route path='/start-point/add/' component={route => <StartPointDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'VIEW_DESTINATION_LIST',
    id: 'DESTINATION',
    action: PERMISSIONS.VIEW_DESTINATION,
    component: <Route path='/destination' key='VIEW_DESTINATION_LIST' exact component={DestinationPage} />,
  }, {
    key: 'UPDATE_DESTINATION',
    id: 'DESTINATION',
    action: PERMISSIONS.UPDATE_DESTINATION,
    component: <Route path='/destination/edit/:id' component={route => <DestinationDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_DESTINATION_DETAIL',
    id: 'DESTINATION',
    action: PERMISSIONS.VIEW_DESTINATION,
    component: <Route path='/destination/view/:id' key='VIEW_DESTINATION_DETAIL' component={route => <DestinationDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_DESTINATION',
    id: 'DESTINATION',
    action: PERMISSIONS.CREATE_DESTINATION,
    component: <Route path='/destination/add/' component={route => <DestinationDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'VIEW_LOGS',
    id: 'LOGS',
    action: PERMISSIONS.VIEW_LOGS,
    component: <Route path='/report' key='VIEW_LOGS' exact component={ReportPage} />,
  }, {
    key: 'VIEW_MECHANIC_LIST',
    id: 'MECHANIC',
    action: PERMISSIONS.VIEW_MECHANIC,
    component: <Route path='/mechanic' key='VIEW_MECHANIC_LIST' exact component={MechanicPage} />,
  }, {
    key: 'UPDATE_MECHANIC',
    id: 'MECHANIC',
    action: PERMISSIONS.UPDATE_MECHANIC,
    component: <Route path='/mechanic/edit/:id' component={route => <MechanicDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'CREATE_SALARY',
    id: 'MECHANIC',
    action: PERMISSIONS.CREATE_SALARY,
    component: <Route path='/mechanic/salary/:id' component={route => <MechanicSalary props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_MECHANIC_DETAIL',
    id: 'MECHANIC',
    action: PERMISSIONS.VIEW_MECHANIC,
    component: <Route path='/mechanic/view/:id' key='VIEW_MECHANIC_DETAIL' component={route => <MechanicDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_MECHANIC',
    id: 'MECHANIC',
    action: PERMISSIONS.CREATE_MECHANIC,
    component: <Route path='/mechanic/add/' component={route => <MechanicDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'VIEW_EXPENSE',
    id: 'EXPENSE',
    action: PERMISSIONS.VIEW_EXPENSE,
    component: <Route path='/expense' key='VIEW_EXPENSE' exact component={ExpensePage} />,
  }, {
    key: 'VIEW_DASHBOARD',
    id: 'DASHBOARD',
    action: PERMISSIONS.VIEW_DASHBOARD,
    component: <Route path='/dashboard' key='VIEW_DASHBOARD' exact component={Dashboard} />,
  }, {
    key: 'VIEW_FUELCOSTSUMMARY',
    id: 'FUELCOSTSUMMARY',
    action: PERMISSIONS.VIEW_FUELCOSTSUMMARY,
    component: <Route path='/fuel-cost-summary' key='VIEW_FUELCOSTSUMMARY' exact component={FuelCostSummary} />,
  }, {
    key: 'VIEW_RECOMMEND_FUEL_LIST',
    id: 'RECOMMEND_FUEL',
    action: PERMISSIONS.CREATE_FUEL_ORDER_OVER_LIMIT,
    component: <Route path='/recommend-fuel' key='VIEW_RECOMMEND_FUEL_LIST' exact component={RecommendFuelPage} />,
  }, {
    key: 'VIEW_REPAIR_JOB_LIST',
    id: 'REPAIR_JOB_LIST',
    action: PERMISSIONS.VIEW_REPAIR,
    component: <Route path='/repair-job' key='VIEW_REPAIR_JOB_LIST' exact component={RepairList} />,
  }, {
    key: 'UPDATE_REPAIR_JOB',
    id: 'REPAIR_JOB',
    action: PERMISSIONS.UPDATE_REPAIR,
    component: <Route path='/repair-job/edit/:id' component={route => <RepairDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_REPAIR_JOB_DETAIL',
    id: 'REPAIR_JOB',
    action: PERMISSIONS.VIEW_REPAIR,
    component: <Route path='/repair-job/view/:id' key='VIEW_REPAIR_JOB_DETAIL' component={route => <RepairDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_REPAIR_JOB',
    id: 'REPAIR_JOB',
    action: PERMISSIONS.CREATE_REPAIR,
    component: <Route path='/repair-job/add/' component={route => <RepairDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'VIEW_GARAGE_LIST',
    id: 'GARAGE',
    action: PERMISSIONS.VIEW_GARAGE,
    component: <Route path='/garage' key='VIEW_GARAGE_LIST' exact component={GaragePage} />,
  }, {
    key: 'UPDATE_GARAGE',
    id: 'GARAGE',
    action: PERMISSIONS.UPDATE_GARAGE,
    component: <Route path='/garage/edit/:id' component={route => <GarageDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_GARAGE_DETAIL',
    id: 'GARAGE',
    action: PERMISSIONS.VIEW_GARAGE,
    component: <Route path='/garage/view/:id' key='VIEW_GARAGE_DETAIL' component={route => <GarageDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_GARAGE',
    id: 'GARAGE',
    action: PERMISSIONS.CREATE_GARAGE,
    component: <Route path='/garage/add/' component={route => <GarageDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'VIEW_TIRE_PATCH_SHOP_LIST',
    id: 'TIRE_PATCH_SHOP',
    action: PERMISSIONS.VIEW_TIREPATCHSTORE,
    component: <Route path='/tire-patch-shop' key='VIEW_TIRE_PATCH_SHOP_LIST' exact component={TirePatchShopPage} />,
  }, {
    key: 'UPDATE_TIRE_PATCH_SHOP',
    id: 'TIRE_PATCH_SHOP',
    action: PERMISSIONS.UPDATE_TIREPATCHSTORE,
    component: <Route path='/tire-patch-shop/edit/:id' component={route => <TirePatchShopDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_TIRE_PATCH_SHOP_DETAIL',
    id: 'TIRE_PATCH_SHOP',
    action: PERMISSIONS.VIEW_TIREPATCHSTORE,
    component: <Route path='/tire-patch-shop/view/:id' key='VIEW_TIRE_PATCH_SHOP_DETAIL' component={route => <TirePatchShopDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_TIRE_PATCH_SHOP',
    id: 'TIRE_PATCH_SHOP',
    action: PERMISSIONS.CREATE_TIREPATCHSTORE,
    component: <Route path='/tire-patch-shop/add/' component={route => <TirePatchShopDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'VIEW_TRAILER_LIST',
    id: 'TRAILER',
    action: PERMISSIONS.VIEW_TRUCK,
    component: <Route key='VIEW_TRAILER_LIST' exact path='/trailer' component={TrailerPage} />,
  }, {
    key: 'UPDATE_TRAILER',
    id: 'TRAILER',
    action: PERMISSIONS.UPDATE_TRUCK,
    component: <Route path='/trailer/edit/:id' component={route => <TrailerDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_TRAILER_DETAIL',
    id: 'TRAILER',
    action: PERMISSIONS.VIEW_TRUCK,
    component: <Route key='VIEW_TRAILER_DETAIL' path='/trailer/view/:id' component={route => <TrailerDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_TRAILER',
    id: 'TRAILER',
    action: PERMISSIONS.CREATE_TRUCK,
    component: <Route path='/trailer/add/' component={route => <TrailerDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'VIEW_TRAILER_LOG',
    id: 'TRAILER',
    action: PERMISSIONS.VIEW_TRUCK,
    component: <Route key='VIEW_TRAILER_LIST' path='/trailer/view-log/:id' component={route => <TrailerViewLog props={{ ...route, match: { ...route.match } }} />} />,
  }, {
    key: 'VIEW_TRAILER_TIRE_LIST',
    id: 'TRAILER',
    action: PERMISSIONS.VIEW_TRUCK,
    component: <Route key='VIEW_TRAILER_TIRE_LIST' path='/trailer/tire-list/:id' component={route => <TrailerTireList props={{ ...route, match: { ...route.match } }} />} />,
  }, {
    key: 'VIEW_TRAILER_TIRE_HISTORY',
    id: 'TRAILER',
    action: PERMISSIONS.VIEW_TRUCK,
    component: <Route key='VIEW_TRAILER_TIRE_HISTORY_LIST' path='/trailer/tire-history/:id' component={route => <TrailerTireHistory props={{ ...route, match: { ...route.match } }} />} />,
  }, {
    key: 'VIEW_TIRE_PATCH_LIST',
    id: 'TIRE_PATCH',
    action: PERMISSIONS.VIEW_TIRE_PATCH,
    component: <Route path='/tire-patch' key='VIEW_GARAGE_LIST' exact component={TirePatchPage} />,
  }, {
    key: 'UPDATE_TIRE_PATCH',
    id: 'TIRE_PATCH',
    action: PERMISSIONS.UPDATE_TIRE_PATCH,
    component: <Route path='/tire-patch/edit/:id' component={route => <TirePatchDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_TIRE_PATCH_DETAIL',
    id: 'TIRE_PATCH',
    action: PERMISSIONS.VIEW_TIRE_PATCH,
    component: <Route path='/tire-patch/view/:id' key='VIEW_GARAGE_DETAIL' component={route => <TirePatchDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_TIRE_PATCH',
    id: 'TIRE_PATCH',
    action: PERMISSIONS.CREATE_TIRE_PATCH,
    component: <Route path='/tire-patch/add/' component={route => <TirePatchDetail props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'VIEW_PURCHASE_ORDER_LIST',
    id: 'PURCHASE_ORDER',
    action: PERMISSIONS.VIEW_PURCHASE_ORDER,
    component: <Route path='/purchase-order' key='VIEW_PURCHASE_ORDER_LIST' exact component={PurchaseOrderPage} />,
  }, {
    key: 'UPDATE_PURCHASE_ORDER',
    id: 'PURCHASE_ORDER',
    action: PERMISSIONS.UPDATE_PURCHASE_ORDER,
    component: <Route path='/purchase-order/edit/:id' component={route => <PurchaseOrderEdit props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_PURCHASE_ORDER_DETAIL',
    id: 'PURCHASE_ORDER',
    action: PERMISSIONS.VIEW_PURCHASE_ORDER,
    component: <Route path='/purchase-order/view/:id' key='VIEW_PURCHASE_ORDER_DETAIL' component={route => <PurchaseOrderView props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_PURCHASE_ORDER',
    id: 'PURCHASE_ORDER',
    action: PERMISSIONS.CREATE_PURCHASE_ORDER,
    component: <Route path='/purchase-order/add/' component={route => <PurchaseOrderEdit props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'VIEW_GOOD_RECEIVED_LIST',
    id: 'GOOD_RECEIVED',
    action: PERMISSIONS.VIEW_GOOD_RECEIVED,
    component: <Route path='/good-received' key='VIEW_GOOD_RECEIVED_LIST' exact component={GoodReceivedPage} />,
  }, {
    key: 'VIEW_GOOD_RECEIVED_DETAIL',
    id: 'GOOD_RECEIVED',
    action: PERMISSIONS.VIEW_GOOD_RECEIVED,
    component: <Route path='/good-received/view/:id' key='VIEW_GOOD_RECEIVED_DETAIL' component={route => <GoodReceivedView props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_GOOD_RECEIVED',
    id: 'GOOD_RECEIVED',
    action: PERMISSIONS.CREATE_GOOD_RECEIVED,
    component: <Route path='/good-received/add/' component={route => <GoodReceivedEdit props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'VIEW_TIRE_GOOD_RECEIVED_LIST',
    id: 'TIRE_GOOD_RECEIVED',
    action: PERMISSIONS.VIEW_TIRE_GOOD_RECEIVED,
    component: <Route path='/tire-good-received' key='VIEW_GOOD_RECEIVED_LIST' exact component={TireGoodReceivedPage} />,
  }, {
    key: 'VIEW_TIRE_GOOD_RECEIVED_DETAIL',
    id: 'TIRE_GOOD_RECEIVED',
    action: PERMISSIONS.VIEW_TIRE_GOOD_RECEIVED,
    component: <Route path='/tire-good-received/view/:id' key='VIEW_GOOD_RECEIVED_DETAIL' component={route => <TireGoodReceivedView props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_TIRE_GOOD_RECEIVED',
    id: 'TIRE_GOOD_RECEIVED',
    action: PERMISSIONS.CREATE_TIRE_GOOD_RECEIVED,
    component: <Route path='/tire-good-received/add/' component={route => <TireGoodReceivedEdit props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'VIEW_INVENTORY_LIST',
    id: 'INVENTORY',
    action: PERMISSIONS.VIEW_INVENTORY,
    component: <Route path='/inventory' exact component={InventoryPage} />,
  }, {
    key: 'UPDATE_INVENTORY',
    id: 'INVENTORY',
    action: PERMISSIONS.UPDATE_INVENTORY,
    component: <Route path='/inventory/edit/:id' component={route => <InventoryEdit props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_INVENTORY_DETAIL',
    id: 'INVENTORY',
    action: PERMISSIONS.VIEW_INVENTORY,
    component: <Route path='/inventory/view/:id' key='VIEW_INVENTORY_DETAIL' component={route => <InventoryView props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_INVENTORY',
    id: 'INVENTORY',
    action: PERMISSIONS.CREATE_INVENTORY,
    component: <Route path='/inventory/add/' component={route => <InventoryEdit props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'TRANSFER_INVENTORY',
    id: 'INVENTORY',
    action: PERMISSIONS.UPDATE_INVENTORY,
    component: <Route path='/inventory/transfer/:id' component={route => <InventoryTransfer props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'ADJUST_INVENTORY',
    id: 'INVENTORY',
    action: PERMISSIONS.UPDATE_INVENTORY,
    component: <Route path='/inventory/adjust/:id' component={route => <InventoryAdjust props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'HISTORY_INVENTORY',
    id: 'INVENTORY',
    action: PERMISSIONS.VIEW_INVENTORY,
    component: <Route path='/inventory/history/:id' component={route => <InventoryHistory props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_TIRE_INVENTORY_LIST',
    id: 'TIRE_INVENTORY',
    action: PERMISSIONS.VIEW_TIRE_INVENTORY,
    component: <Route path='/tire-inventory' exact component={TireInventoryPage} />,
  }, {
    key: 'UPDATE_TIRE_INVENTORY',
    id: 'TIRE_INVENTORY',
    action: PERMISSIONS.UPDATE_TIRE_INVENTORY,
    component: <Route path='/tire-inventory/edit/:id' component={route => <TireInventoryEdit props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_TIRE_INVENTORY_DETAIL',
    id: 'TIRE_INVENTORY',
    action: PERMISSIONS.VIEW_TIRE_INVENTORY,
    component: <Route path='/tire-inventory/view/:id' key='VIEW_INVENTORY_DETAIL' component={route => <TireInventoryView props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_TIRE_INVENTORY',
    id: 'TIRE_INVENTORY',
    action: PERMISSIONS.CREATE_TIRE_INVENTORY,
    component: <Route path='/tire-inventory/add/' component={route => <TireInventoryEdit props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'TRANSFER_TIRE_INVENTORY',
    id: 'TIRE_INVENTORY',
    action: PERMISSIONS.UPDATE_TIRE_INVENTORY,
    component: <Route path='/tire-inventory/transfer/:id' component={route => <TireInventoryTransfer props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'ADJUST_TIRE_INVENTORY',
    id: 'TIRE_INVENTORY',
    action: PERMISSIONS.UPDATE_TIRE_INVENTORY,
    component: <Route path='/tire-inventory/adjust/:id' component={route => <TireInventoryAdjust props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'HISTORY_TIRE_INVENTORY',
    id: 'TIRE_INVENTORY',
    action: PERMISSIONS.VIEW_TIRE_INVENTORY,
    component: <Route path='/tire-inventory/history/:id' component={route => <TireInventoryHistory props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'HISTORY_TIRE_INVENTORY',
    id: 'TIRE_INVENTORY',
    action: PERMISSIONS.VIEW_TIRE_INVENTORY,
    component: <Route path='/tire-inventory/used-history/:id' component={route => <TireInventoryUsedHistory props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_SUPPLIER_LIST',
    id: 'SUPPLIER',
    action: PERMISSIONS.VIEW_SUPPLIER,
    component: <Route path='/supplier' key='VIEW_GARAGE_LIST' exact component={SupplierPage} />,
  }, {
    key: 'UPDATE_SUPPLIER',
    id: 'SUPPLIER',
    action: PERMISSIONS.UPDATE_SUPPLIER,
    component: <Route path='/supplier/edit/:id' component={route => <SupplierEdit props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_SUPPLIER_DETAIL',
    id: 'SUPPLIER',
    action: PERMISSIONS.VIEW_SUPPLIER,
    component: <Route path='/supplier/view/:id' key='VIEW_SUPPLIER_DETAIL' component={route => <SupplierView props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_SUPPLIER',
    id: 'SUPPLIER',
    action: PERMISSIONS.CREATE_SUPPLIER,
    component: <Route path='/supplier/add/' component={route => <SupplierEdit props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'VIEW_WAREWHOUSE_LIST',
    id: 'WAREWHOUSE',
    action: PERMISSIONS.VIEW_WAREHOUSE,
    component: <Route path='/warehouse' key='VIEW_WAREHOUSE_LIST' exact component={WarehousePage} />,
  }, {
    key: 'UPDATE_WAREWHOUSE',
    id: 'WAREWHOUSE',
    action: PERMISSIONS.UPDATE_WAREHOUSE,
    component: <Route path='/warehouse/edit/:id' component={route => <WarehouseEdit props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'edit' } } }} />} />,
  }, {
    key: 'VIEW_WAREWHOUSE_DETAIL',
    id: 'WAREWHOUSE',
    action: PERMISSIONS.VIEW_WAREHOUSE,
    component: <Route path='/warehouse/view/:id' key='VIEW_MECHANIC_DETAIL' component={route => <WarehouseView props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'view' } } }} />} />,
  }, {
    key: 'CREATE_WAREWHOUSE',
    id: 'WAREWHOUSE',
    action: PERMISSIONS.CREATE_WAREHOUSE,
    component: <Route path='/warehouse/add/' component={route => <WarehouseEdit props={{ ...route, match: { ...route.match, params: { ...route.match.params, mode: 'add' } } }} />} />,
  }, {
    key: 'VIEW_DRIVER_COMPENSATION',
    id: 'DRIVER_COMPENSATION',
    action: PERMISSIONS.VIEW_FUEL,
    component: <Route path='/driver-compensation' component={route => <DriverCompensation props={{ ...route, match: { ...route.match } }} />} />,
  }, {
    key: 'VIEW_JOB_HISTORY',
    id: 'JOB_HISTORY',
    action: PERMISSIONS.VIEW_JOB,
    component: <Route path='/job/history/:id' component={route => <JobHistory props={{ ...route, match: { ...route.match } }} />} />,
  }, {
    key: 'VIEW_TRUCK_HISTORY',
    id: 'TRUCK_HISTORY',
    action: PERMISSIONS.VIEW_TRUCK,
    component: <Route path='/truck/driver-history/:id' component={route => <TruckHistory props={{ ...route, match: { ...route.match } }} />} />,
  }, {
    key: 'VIEW_SHIPPING_ORDER_HISTORY',
    id: 'SHIPPING_ORDER_HISTORY',
    action: PERMISSIONS.VIEW_SHIPPING_ORDER,
    component: <Route path='/shipping-order/history/:id' component={route => <ShippingOrderHistory props={{ ...route, match: { ...route.match } }} />} />,
  },
]

export default (menuKeys, perms) => routes.filter(v => _.includes(perms, v.action))
